import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import * as jwtDecode from 'jwt-decode';
import { AuthService } from 'ngx-auth';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/startWith';

import { config } from '../../../config';
import { SessionService } from './session.service';

export interface TokenResponse {
  access_token: string;
}

@Injectable()
export class TokenService implements AuthService {
  invalidTokenEmitter = new EventEmitter<void>();
  private accessToken: BehaviorSubject<string>;

  constructor(private http: HttpClient, private session: SessionService) {
    this.accessToken = new BehaviorSubject(
      this.session.get('access_token')
    );

    this.accessToken.subscribe(
      accessToken => this.session.set('access_token', accessToken)
    );
  }

  isAuthorized(): Observable<boolean> {
    return this.accessToken.map(this.validateToken);
  }

  setAccessToken(value: string) {
    this.accessToken.next(value);
  }

  getAccessToken(): Observable<string> {
    return this.accessToken;
  }

  getClaims(): Observable<{ [key: string]: any } | null> {
    return this.getAccessToken().map(token => {
      try {
        return jwtDecode(token);
      } catch (e) {
        return null;
      }
    });
  }

  refreshToken() {
    return this.http
      .post<TokenResponse>(`${config.apiLocation}/auth/refresh`, { token: this.accessToken.getValue() })
      .map(data => this.setAccessToken(data.access_token))
      .catch(err => {
        this.invalidTokenEmitter.emit();
        return err;
      });
  }

  refreshShouldHappen(response: HttpErrorResponse): boolean {
    return response.status === 401;
  }

  verifyTokenRequest(url: string): boolean {
    return [
      `${config.apiLocation}/auth/refresh`,
      `${config.apiLocation}/auth/logout`,
    ].includes(url);
  }

  private validateToken(token: string): boolean {
    try {
      jwtDecode(token);

      // Could still refresh
      // return isFuture(decoded.exp * 1000);
    } catch (e) {
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/token.service.ts